import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import AppErrorBoundary from './AppErrorBoundary';
import UnreadNotificationGate from './UnreadNotificationGate';
import PushActivationNudge from './PushActivationNudge';
import AdminOnlyCommunityLayer from './AdminOnlyCommunityLayer';
import AdminReviewImageModerationLayer from './AdminReviewImageModerationLayer';
import SampleAccessLayer from './SampleAccessLayer';
import ReviewDeepLinkPage, { reviewIdFromPath } from './ReviewDeepLinkPage';
import FeedbackDeepLinkPage, { isFeedbackPath } from './FeedbackDeepLinkPage';
import { expireStaleSampleSession } from './sampleAccess';
import { LocationProvider } from './location/LocationProvider';
import reportWebVitals from './reportWebVitals';
import { installProductAnalytics, trackProductEvent } from './productAnalytics';
import { bootstrapRestaurantInvite, restaurantInviteEventMetadata } from './restaurantInviteAccess';
import { installRelatedPlaceNavigationEnhancements } from './relatedPlaceNavigationEnhancements';

const reviewId = reviewIdFromPath(window.location.pathname);
const feedbackPath = isFeedbackPath(window.location.pathname, window.location.hash);

expireStaleSampleSession();
const restaurantInviteSession = bootstrapRestaurantInvite();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <AppErrorBoundary>
      {reviewId ? <ReviewDeepLinkPage reviewId={reviewId} /> : feedbackPath ? <FeedbackDeepLinkPage /> : <>
        <LocationProvider><App /></LocationProvider>
        <UnreadNotificationGate />
        <PushActivationNudge />
        <SampleAccessLayer />
        <AdminOnlyCommunityLayer />
        <AdminReviewImageModerationLayer />
      </>}
    </AppErrorBoundary>
  </React.StrictMode>
);

installProductAnalytics();
installRelatedPlaceNavigationEnhancements();
if (restaurantInviteSession?.openedNow) {
  void trackProductEvent('restaurant_invite_open', restaurantInviteEventMetadata(restaurantInviteSession));
}
reportWebVitals();
